import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

export const ClaimsSchema = z.object({
  // Standard JWT claims
  // iss: z.url(),
  // sub: z.string(),
  // iat: z.number(),
  // nbf: z.number(),
  // exp: z.number(),
  // jti: z.string(),
  // sid: z.string(),
  // sts: z.string(),
  // fva: z.tuple([z.number().int(), z.number().int()]),

  // Custom claims
  // created_at: z.number().int(),
  // email_verified: z.boolean(),
  // external_id: z.string().nullable(),
  first_name: z.string(),
  // full_name: z.string(),
  last_name: z.string(),
  // last_signed_in: z.number().int(),
  // org_id: z.string().nullable(),
  // org_name: z.string().nullable(),
  // org_permissions: z.unknown().nullable(),
  // org_slug: z.string().nullable(),
  // phone_number: z.string().nullable(),
  primary_email: z.email(),
  // user_public_metadata: z.record(z.unknown()),
})

export type Claims = ZodInfer<typeof ClaimsSchema>

export const VolatileClaims = ClaimsSchema.extend({
  primary_email: z
    .union([
      z.string().email(),
      z.object({
        emailAddress: z.string().email(),
      }),
    ])
    .transform((val) => (typeof val === 'string' ? val : val.emailAddress)),
})

export const MntnClaimsSchema = z.object({
  mntn_primary_email: z.email(),
  // mntn_email: z.email(),
  // mntn_email_verified: z.boolean(),
  mntn_first_name: z.string(),
  // mntn_full_name: z.string(),
  mntn_last_name: z.string(),
  // mntn_username: z.string(),
  // mntn_profile_image_url: z.url().optional(),
  // mntn_created_at: 2025-10-28T22:08:01.406Z,
  // mntn_updated_at: 2025-11-10T20:19:59.911Z,
  // mntn_deprecated_clerk_user_id: z.string(),
})

export type MntnClaims = ZodInfer<typeof MntnClaimsSchema>

export const AccessTokenSchema = ClaimsSchema.extend({
  sub: z.string(),
  sid: z.string().optional(),

  first_name: z.string().optional(),
  last_name: z.string().optional(),
  primary_email: z.string().optional(),
  mntn_first_name: z.string().optional(),
  mntn_last_name: z.string().optional(),
  mntn_primary_email: z.string().optional(),
}).transform((claims) => {
  const firstName = claims.first_name ?? claims.mntn_first_name
  const lastName = claims.last_name ?? claims.mntn_last_name
  const primaryEmail = claims.primary_email ?? claims.mntn_primary_email

  if (!firstName)
    throw new Error('Missing first name claim (first_name or mntn_first_name)')
  if (!lastName)
    throw new Error('Missing last name claim (last_name or mntn_last_name)')
  if (!primaryEmail)
    throw new Error(
      'Missing primary email claim (primary_email or mntn_primary_email)'
    )

  return {
    ...claims,
    first_name: firstName,
    last_name: lastName,
    primary_email: primaryEmail,
    sid: claims.sid ?? claims.sub,
  }
})

export type AccessToken = ZodInfer<typeof AccessTokenSchema>
